import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { images } from '../../assets/images';
import { LOGOUT_ACTION_SESSION_CODE_PARAM } from '../../model/store';
import { RhButton, RhButtonMode } from './RhButton';
import { colors, H2, Regular } from './Styles';

export const EmailVerificationScreen: React.FC = () => {
  const { logout } = useAuth0();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('error') || urlParams.get('error_description') || urlParams.get('state')) {
      const cleanUrl = location.pathname;
      history.replace(cleanUrl);
    }
  }, [location, history]);

  const handleBackToLogin = () => {
    const returnTo = `${window.location.origin}?session=${LOGOUT_ACTION_SESSION_CODE_PARAM}`;
    logout({ returnTo });
  };

  return (
    <Container>
      <Content>
        <LogoContainer>
          <Logo src={images.risenHopeLogo} alt="RISENHOPE" />
        </LogoContainer>

        <Heading>Verify your email</Heading>

        <MessageContainer>
          <Message>Your email is not verified. Please verify it before logging in.</Message>
          <Message>You must have received an email with a verification link.</Message>
        </MessageContainer>

        <ButtonContainer>
          <RhButton mode={RhButtonMode.primary} title="Back to Login" onClick={handleBackToLogin} />
        </ButtonContainer>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.background};
  padding: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  width: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
`;

const Logo = styled.img`
  height: 60px;
  width: auto;
  object-fit: contain;
`;

const Heading = styled(H2)`
  text-align: center;
  margin-bottom: 24px;
  color: ${colors.normal};
  font-weight: 700;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
  gap: 12px;
`;

const Message = styled(Regular)`
  color: ${colors.normal};
  font-size: 16px;
  line-height: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 300px;
`;
